import { type AxiosInstance, type AxiosRequestConfig } from 'axios';

import type { CustomErrorInterceptor } from './localApiAxiosErrorInterceptors';

import { appConfig } from '../../../../appConfig';
import { createDefaultException } from '../../exceptions/exceptionUtils';
import axiosClientFactory from './clientFactory';

interface ApiProfileValidationException {
    type: string;
    title: string;
    status: number;
    errors: Record<string, string[]>;
}

const isValidationException = (error: unknown): error is ApiProfileValidationException => {
    return error !== null && (error as ApiProfileValidationException).errors !== undefined;
};

const customErrorInterceptor: CustomErrorInterceptor = (error) => {
    if (error.response.status === 400 && isValidationException(error.response.data)) {
        if (error.response.data.errors.MaxLimitReached) {
            return createDefaultException('Maximum limit reached', 'MAX_PRODUCT_LIMIT_REACHED');
        }
    }

    return createDefaultException();
};

const directProfileApiAxiosClient = (accessToken: string): AxiosInstance => {
    const axiosRequestConfig: AxiosRequestConfig = {
        baseURL: appConfig.coopSettings.serviceAccess.userProfileApiUrl,
        headers: {
            'Ocp-Apim-Subscription-Key':
                appConfig.coopSettings.serviceAccess.userProfileApiSubscriptionKey,
            Authorization: `Bearer ${accessToken}`,
        },
        params: appConfig.coopSettings.serviceAccess.userProfileApiVersion
            ? { 'api-version': appConfig.coopSettings.serviceAccess.userProfileApiVersion }
            : undefined,
    };

    const directSearchAxiosClient = axiosClientFactory.createDirectApiClient(axiosRequestConfig, [
        customErrorInterceptor,
    ]);

    return directSearchAxiosClient;
};

export default directProfileApiAxiosClient;
